// extracted by mini-css-extract-plugin
export default {"cardContainer":"Home_cardContainer__I5IU+"};